import classNames from "classnames";

export const EnvironmentLabel = () => {
  const mode = import.meta.env.MODE;

  if (mode === "prod") {
    return null;
  }

  let style = "";
  switch (mode) {
  case "local-dev":
    style = "border-blue-500 text-white";
    break;
  case "dev":
    style = "border-green-500 text-black";
    break;
  case "test":
    style = "border-yellow-500 text-black";
    break;
  case "stage":
    style = "border-orange-500 text-black";
    break;
  }

  return (
    <div className={classNames(style,
      "z-[9000] fixed top-0 left-0 right-0 border-t-4 pointer-events-none")}>
      <div className={classNames(style,
        "mx-auto border-t-[14px] w-[96px] border-l-[14px] border-r-[14px]",
        "border-l-transparent border-r-transparent")}>
        <div className="-mt-4 text-center text-xs uppercase">
          {mode}
        </div>
      </div>
    </div>
  );
};
